<div class="panel flex column left-panel-wrapper" [class.collapsed]="!isExpanded" [class.disabled]="!isMapView || !isEnabled" [style.width.px]="width && isExpanded ? dragWidth : 35" (mouseup)="onMouseUp($event)">
    <div class="panel-name left-panel-name">
        <span>Layers</span>
        <button (click)="onExpandedClick()" class="panel-toggle-icon"><mat-icon>{{isExpanded ? 'first_page' :
                'last_page'}}</mat-icon></button>
    </div>
    <div class="panel-body details-expanded">
        <div class="overlay-list left-panel-inner-wrapper">
            <ul class="tree" style="display: inline-block;">
                <!-- Unified Sorted Groups Rendering -->
                <ng-template #unifiedTreeView let-groups>
                    <li *ngFor="let groupNode of groups" class="tree-row left-panel-rows">
                        <hr class="menu-line-separator" />
                        <div class="tree-node">
                            <div class="node-navigation">
                                <mat-icon class="mat-icon-rtl-mirror" (click)="groupNode.isOpen = !groupNode.isOpen"
                                    *ngIf="(groupNode.children.length || groupNode.overlays.length) && groupNode.group.tag !== 'locations'">
                                    {{groupNode.isOpen ? 'expand_more' : 'chevron_right'}}
                                </mat-icon>
                            </div>
                            <!-- Show checkbox for Locations, label for other groups -->
                            <mat-checkbox *ngIf="groupNode.group.tag === 'locations'" [disableRipple]="true" [(ngModel)]="groupNode.isSelected"
                                (ngModelChange)="overlayWasToggled(groupNode.overlays[0], null, groupNode.isSelected)">
                                <span class="tree-overlay" (click)="selectOverlay(groupNode.overlays[0], $event)">{{ groupNode.group.name | decodeHtml }}</span>
                            </mat-checkbox>
                            <label *ngIf="groupNode.group.tag !== 'locations'" class="group-label">{{ groupNode.group.name | decodeHtml }}</label>
                        </div>

                        <ul [hidden]="!(groupNode.isOpen && groupNode.children?.length > 0)">
                            <ng-container
                                *ngTemplateOutlet="unifiedTreeView;  context:{ $implicit: groupNode.children }"></ng-container>
                        </ul>
                        <ul [hidden]="!groupNode.isOpen || groupNode.group.tag === 'locations'">
                            <div *ngFor="let overlay of groupNode.overlays" class="tree-row">
                                <div class="tree-node"
                                    [ngClass]="{'selected': overlay.id === selectedOverlay?.id, 'no-bg': colorizationBoxIsClosed}">
                                    <div class="node-navigation"></div>
                                    <mat-checkbox [disableRipple]="true"
                                        [disabled]="!accountOverlaysByIds.get(overlay.id)"
                                        [(ngModel)]="overlay.isSelected"
                                        (ngModelChange)="groupNode.group.name === 'Weather and Conditions' ? imageOverlayWasToggled(overlay, overlay.isSelected, true) : overlayWasToggled(overlay, groupNode, overlay.isSelected)">
                                        <span class="tree-overlay"
                                            (click)="selectOverlay(overlay, $event)">{{ overlay.name | decodeHtml }}</span>
                                    </mat-checkbox>
                                </div>
                            </div>
                        </ul>
                    </li>
                </ng-template>
                <ng-container *ngTemplateOutlet="unifiedTreeView; context:{ $implicit: allSortedGroups }"></ng-container>
            </ul>
        </div>

        <div *ngIf="selectedOverlay"
            [ngClass]="{'collapsed-box': !colorizationBoxIsExpanded, 'display-none': colorizationBoxIsClosed}"
            class="overlay-details cursor-pointer" style="border-top: 0.8px solid #cccc;">
            <div class="panel-name panel-title-head">

                    <span [matTooltip]="selectedOverlay.name | decodeHtml" matTooltipPosition="left">{{ selectedOverlay.name | decodeHtml }}</span>

                <span class="btns-container">
                    <mat-icon aria-hidden="false" (click)="colorizationBoxIsExpanded = !colorizationBoxIsExpanded">
                        {{colorizationBoxIsExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
                    </mat-icon>
                    <span class="close-btn" (click)="closeColorizationBox()">
                        <!-- cross-icon -->
                        <svg width="9" height="9" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
                            <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="#0044F1" stroke-width="1.5">
                                <path d="m1 1 3.333 3.333L1 7.667"/>
                                <path d="M7.333 1 4 4.333l3.333 3.334"/>
                            </g>
                        </svg>
                    </span>
                </span>
            </div>
            <div class="overlay-content" *ngIf="colorizationBoxIsExpanded">
                <mpt-colorization-box *ngIf="dataset" [dataset]="selectedOverlay"
                    (resetRenderingOptions)="resetRenderingOptions($event)" [accountApplicationDataset]="dataset"
                    [renderingOptions]="overlaysRenderingOptions.get(selectedOverlay.id)"
                    (overlaySettingsUpdated)="onOverlaySettingsUpdate($event)">
                </mpt-colorization-box>
            </div>
        </div>

        <div *ngIf="selectedImageOverlay"
            [ngClass]="{'collapsed-box': !imageOverlayOpacityBoxIsExpended, 'display-none': imageOverlayOpacityBoxIsClosed}"
            class="overlay-details image-overlay-container cursor-pointer">
            <div class="panel-name">
                <span [matTooltip]="selectedImageOverlay.name | decodeHtml"
                    matTooltipPosition="left">{{ selectedImageOverlay.name | decodeHtml }}</span>
                <span class="btns-container">
                    <mat-icon aria-hidden="false"
                        (click)="imageOverlayOpacityBoxIsExpended = !imageOverlayOpacityBoxIsExpended">
                        {{imageOverlayOpacityBoxIsExpended ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}
                    </mat-icon>
                    <span class="close-btn" (click)="closeBox()">
                         <!-- cross-icon -->
                         <svg width="9" height="9" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
                            <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="#0044F1" stroke-width="1.5">
                                <path d="m1 1 3.333 3.333L1 7.667"/>
                                <path d="M7.333 1 4 4.333l3.333 3.334"/>
                            </g>
                        </svg>
                    </span>
                </span>

            </div>
            <div class="overlay-content" *ngIf="imageOverlayOpacityBoxIsExpended">
                <div class="colorization-cell">
                    <div class="colorization-label">OPACITY</div>
                    <mat-slider class="example-margin" min="0" max="1" step="0.1" color="accent"
                        [(ngModel)]="imageOverlayOpacity">
                    </mat-slider>
                </div>
            </div>
        </div>


        <div id="aerisLegend" class="overlay-legends"></div>

        <div>
            <div class="grabber" (mousedown)="onMouseDown($event)">
                <i class="fas fa-ellipsis-v"></i>
            </div>
        </div>
    </div>
</div>

